import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavListCommonProps } from 'src/app/components/nav/nav.component';
import { environment } from 'src/environments/environment';
import { GroupBy } from '../_enums/groupby';
import { SiteMapUrl } from '../_enums/sitemap.url';
import { Ceu } from '../_models/ceu';
import { Combustible, DictionaryEntry } from '../_models/combustible';
import { AuthService } from './auth.service';
import { LabelMenu } from '../_enums/label.menu';
import { EnergieService } from './energie.service';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export interface DredgingFuel {
  id: string;
  displayName: string;
  co2PerLiter: number;
  co2PerMj: number;
}

@Injectable({
  providedIn: 'root'
})
export class DredgingService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router
  ) {}

  get(combustibleId: string) {
    return this.http.get<Combustible>(`${environment.apiUrl}/Dredging/${combustibleId}`, { headers: this.authService.headers });
  }

  getDefaultFuel() {
    return this.http.get<DredgingFuel>(`${environment.apiUrl}/Dredging/default`, { headers: this.authService.headers });
  }

  getAll(groupBy?: string) {
    return this.http.get<Combustible[]>(`${environment.apiUrl}/Dredging?groupBy=${groupBy}`, { headers: this.authService.headers });
  }

  update(combustible: Combustible) {
    return this.http.put<Combustible>(`${environment.apiUrl}/Dredging/${combustible.resourceId}`, combustible, { headers: this.authService.headers });
  }

  add(combustible: Combustible) {
    return this.http.post<Combustible>(`${environment.apiUrl}/Dredging`, combustible, { headers: this.authService.headers });
  }

  delete(resourceId: string) {
    return this.http.delete(`${environment.apiUrl}/Dredging/${resourceId}`, { headers: this.authService.headers });
  }
}
